import { render, staticRenderFns } from "./IconScooling.vue?vue&type=template&id=15174e18&"
import script from "./IconScooling.vue?vue&type=script&lang=js&"
export * from "./IconScooling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports